import APIClient from '@/shared/http/clients/api'

const resourceName = 'quadrofuncionariohistorico'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (quadrofuncionarioID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/quadrofuncionario/${quadrofuncionarioID}`, data, config)
const GetAllPaging = (quadrofuncionarioID, limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/quadrofuncionario/${quadrofuncionarioID}?limit=${limit}&index=${index}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)

const EmployeeBoardItemRepository = {
  GetAll,
  GetAllPaging,
  Create
}

export default EmployeeBoardItemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/employeeboardhistory.js